import { IApplicationState } from '@Site/rootReducer'
import { createSelector } from 'reselect'

export const getExternalChannels = (state: IApplicationState) => state.externalChannels.externalChannels

export const getHasExternalChannels = createSelector(
  [getExternalChannels],
  (externalChannels) => externalChannels.length > 0
)
